import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "../../../../../environments/environment";
import { Oauth2TokenService } from "../../../../../services/oauth2-token.service";
import { GlobalConfig } from "../../../../shared/config/global-config";
import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { RecebivelUpdated } from "../../recebiveis/models/recebivel-updated";
import { Pagination } from "../models/pagination";
import { SearchResult } from "../models/search-result";
import { Transacao } from "../models/transacao";
import { TransacaoAddModel } from "../models/transacao-add.model";
import { TransacaoUpdated } from "../models/transacao-updated";
import { HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable()
export class TransacoesService {
  transacoesUrl: string;
  transactionsUrl: string;
  recebivelUrl: string;
  transacoesGridUrl: string;
  organizacaoUrl: string;
  transacoesAddUrl: string;
  planoSaudeUrl: string;
  medicoPlanoSaudeUrl: string;
  transacoes: Transacao[] = [];
  pagination: Pagination[] = [];
  vendorTransactionsDeleteUrl: string;

  constructor(
    private http: HttpInterceptor,
    private router: Router,
    private oauth2Token: Oauth2TokenService
  ) {
    this.recebivelUrl = environment.api.base_url + "/api/v1/recebivel";
    this.transacoesUrl = environment.api.base_url + "/api/v1/transacao";
    this.transactionsUrl = environment.api.base_url + "/api/v2/transactions";
    this.transacoesGridUrl =
      environment.api.base_url + "/api/v1/transacao/grid";
    this.transacoesAddUrl =
      environment.api.base_url + "/api/v1/transacao/storeOrUpdate";
    this.organizacaoUrl = environment.api.base_url + "/api/v1/organizacao";
    this.vendorTransactionsDeleteUrl =
      environment.api.base_url + "/api/v1/transacao/vendedor";
  }

  getHeaders() {
    const accessToken = this.oauth2Token.getTokens().accessToken;

    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    });
  }

  getSearchResult(params?: HttpParams): Observable<SearchResult> {
    return this.http
      .get(this.transacoesUrl, {
        headers: this.getHeaders(),
        params,
      })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<TransacaoUpdated>();
          res.data.forEach((e) => {
            result.push(
              new TransacaoUpdated(
                e.id,
                e.valor_total,
                e.valor_taxa,
                e.tipo_pagamento === "credito" ? "Crédito" : "Débito",
                e.transacao_status_id,
                e.transacao_created_at,
                e.transacao_updated_at,
                e.transacao_cartao.data[0].primeiros_4_digitos,
                e.parcela_qtd,
                e.transacao_cartao.data[0].bandeira,
                e.transacao_cartao.data[0].nome
                  ? e.transacao_cartao.data[0].nome
                  : "Não informado",
                undefined,
                undefined,
                e.vendedor.data.plano_id ===
                GlobalConfig.PLANO_PARTICULAR_TIPO_PRO
                  ? "Pro"
                  : "Standard",
                e.externo_id
              )
            );
          });

          let searchResult = new SearchResult(result, res.meta.pagination);

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.transacoes = newRes.transacoes.map((transacao) => {
            switch (transacao.status) {
              case GlobalConfig.TRANSACAO_STATUS_NOVA:
                transacao.status = "Novo";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PENDENTE:
                transacao.status = "Pendente";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PRE_AUTORIZADA:
                transacao.status = "Pré-autorizado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_APROVADA:
                transacao.status = "Aprovada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_FALHADA:
                transacao.status = "Falhou";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Invertido";
                break;
              case GlobalConfig.TRANSACAO_STATUS_CANCELADA:
                transacao.status = "Cancelada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Reembolsado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_DISPUTA:
                transacao.status = "Disputa";
                break;
              case GlobalConfig.TRANSACAO_STATUS_COBRADO_DE_VOLTA:
                transacao.status = "Estorno";
                break;
            }

            switch (transacao.tipo_pagamento) {
              case "debit":
                transacao.tipo_pagamento = "Débito";
                break;
              case "credit":
                transacao.tipo_pagamento = "Crédito";
                break;
            }

            return transacao;
          });
          return newRes;
        })
      );
  }

  getSearchResultGrid(params?: HttpParams): Observable<SearchResult> {
    return this.http
      .get(this.transacoesGridUrl, {
        headers: this.getHeaders(),
        params,
      })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<TransacaoUpdated>();
          res.data.forEach((e) => {
            result.push(
              new TransacaoUpdated(
                e.transacao_id,
                e.transacao_valor_total,
                undefined,
                e.transacao_tipo_pagamento,
                e.transacao_status_id,
                e.transacao_created_at,
                undefined,
                e.transacao_cartao_primeiros_4_digitos,
                e.transacao_parcela_qtd,
                e.transacao_cartao_bandeira,
                undefined,
                undefined,
                undefined,
                e.plano_descricao ? e.plano_descricao : null,
                e.transacao_numero_serial && e.transacao_numero_serial,
                e.vendedor_nome && e.vendedor_nome,
                e.transacao_taxa && e.transacao_taxa,
                e.transacao_sob_suspeita,
                e.transacao_externo_id
              )
            );
          });

          let searchResult = new SearchResult(result, res.meta.pagination);

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.transacoes = newRes.transacoes.map((transacao) => {
            switch (transacao.status) {
              case GlobalConfig.TRANSACAO_STATUS_NOVA:
                transacao.status = "Novo";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PENDENTE:
                transacao.status = "Pendente";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PRE_AUTORIZADA:
                transacao.status = "Pré-autorizado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_APROVADA:
                transacao.status = "Aprovada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_FALHADA:
                transacao.status = "Falhou";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Invertido";
                break;
              case GlobalConfig.TRANSACAO_STATUS_CANCELADA:
                transacao.status = "Cancelada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Reembolsado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_DISPUTA:
                transacao.status = "Disputa";
                break;
              case GlobalConfig.TRANSACAO_STATUS_COBRADO_DE_VOLTA:
                transacao.status = "Estorno";
                break;
            }

            switch (transacao.tipo_pagamento) {
              case "debit":
                transacao.tipo_pagamento = "Débito";
                break;
              case "credit":
                transacao.tipo_pagamento = "Crédito";
                break;
            }
            return transacao;
          });
          return newRes;
        })
      );
  }

  syncTransaction(externalId: string): Observable<any> {
    const url = `${this.transactionsUrl}/handle-webhook`;
    const body = {
      type: "transaction.",
      payload: {
        object: {
          id: externalId,
        },
      },
    };

    return this.http.post(url, body, { headers: this.getHeaders() });
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  deleteVendorTransactions(id) {
    const url = `${this.vendorTransactionsDeleteUrl}/${id}`;
    return this.http
      .delete(url, { headers: this.getHeaders() })
      .toPromise()
      .then((res) => {
        let responseJson = res;
      })
      .catch(this.handleError);
  }

  getRecebiveis(params?: HttpParams): Observable<any> {
    return this.http
      .get(this.recebivelUrl, {
        headers: this.getHeaders(),
        params,
      })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<any>();
          res.data.forEach((e) => {
            result.push(
              new RecebivelUpdated(
                e.id,
                e.transacao_recebivel_status_id,
                e.transacao_split_id,
                e.regra_divisao,
                e.valor,
                e.valor_bruto,
                e.valor_taxa_antecipacao,
                e.reembolsavel_rejeicao,
                e.parcela === null ? "À vista" : e.parcela,
                e.data_pagamento,
                e.data_pagamento_calculada,
                e.data_previsao_recebimento,
                e.vendedor.data.detalhe.data.cnpj
                  ? e.vendedor.data.detalhe.data.dono_nome
                  : e.vendedor.data.detalhe.data.nome,
                undefined,
                e.transacao.data.parcela_qtd
              )
            );
          });

          let searchResult = {
            recebiveis: result,
            pagination: res.meta.pagination,
          };

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.recebiveis = newRes.recebiveis.map((recebivel) => {
            switch (recebivel.transacao_recebivel_status_id) {
              case "7bc41254-53f9-4d82-83c6-e7466a956712":
                recebivel.status = "Pendente";
                break;
              case "f98796b7-2086-4307-bd33-6cc6b060aa11":
                recebivel.status = "Pago";
                break;
              case "0b4333b3-7c22-4b3b-b42c-24d78949cb15":
                recebivel.status = "Cancelado";
                break;
              case "726fab9d-20c8-468d-bea8-ac4d2fcc2ad4":
                recebivel.status = "Reembolsado";
                break;

              default:
                recebivel.status = "Pendente";
            }

            return recebivel;
          });
          return newRes;
        })
      );
  }

  getTransacao(id: string): Observable<TransacaoUpdated> {
    let headers = this.getHeaders();
    let params = new HttpParams()
      .set("id", id)
      .set(
        "include",
        "transacao_cartao,transacao_taxa,vendedor,vendedor.detalhe"
      );

    return this.http
      .get(this.transacoesUrl, { params: params, headers: headers })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<TransacaoUpdated>();
          res.data.forEach((e) => {
            result.push(
              new TransacaoUpdated(
                e.id,
                e.valor_total,
                e.valor_taxa,
                e.tipo_pagamento === "credito" ? "Crédito" : "Débito",
                e.transacao_status_id,
                e.transacao_created_at,
                e.transacao_updated_at,
                e.transacao_cartao.data.length &&
                  e.transacao_cartao.data[0].primeiros_4_digitos,
                e.parcela_qtd,
                e.transacao_cartao.data.length &&
                  e.transacao_cartao.data[0].bandeira,
                e.transacao_cartao.data.length &&
                e.transacao_cartao.data[0].nome
                  ? e.transacao_cartao.data[0].nome
                  : "Não informado",
                e.transacao_cartao.data.length &&
                  e.transacao_cartao.data[0].validade_mes +
                    "/" +
                    e.transacao_cartao.data[0].validade_ano,
                e.vendedor.data.detalhe.data.cnpj
                  ? e.vendedor.data.detalhe.data.dono_nome
                  : e.vendedor.data.detalhe.data.nome,
                e.vendedor.data.plano_id ===
                GlobalConfig.PLANO_PARTICULAR_TIPO_PRO
                  ? "Pro"
                  : "Standard",
                undefined,
                undefined,
                e.transacao_taxa.data,
                e.sob_suspeita,
                e.externo_id
              )
            );
          });

          let searchResult = new SearchResult(result, res.meta.pagination);

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.transacoes = newRes.transacoes.map((transacao) => {
            switch (transacao.status) {
              case GlobalConfig.TRANSACAO_STATUS_NOVA:
                transacao.status = "Novo";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PENDENTE:
                transacao.status = "Pendente";
                break;
              case GlobalConfig.TRANSACAO_STATUS_PRE_AUTORIZADA:
                transacao.status = "Pré-autorizado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_APROVADA:
                transacao.status = "Aprovada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_FALHADA:
                transacao.status = "Falhou";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Invertido";
                break;
              case GlobalConfig.TRANSACAO_STATUS_CANCELADA:
                transacao.status = "Cancelada";
                break;
              case GlobalConfig.TRANSACAO_STATUS_REVERTIDA:
                transacao.status = "Reembolsado";
                break;
              case GlobalConfig.TRANSACAO_STATUS_DISPUTA:
                transacao.status = "Disputa";
                break;
              case GlobalConfig.TRANSACAO_STATUS_COBRADO_DE_VOLTA:
                transacao.status = "Estorno";
                break;
            }

            switch (transacao.tipo_pagamento) {
              case "debit":
                transacao.tipo_pagamento = "Débito";
                break;
              case "credit":
                transacao.tipo_pagamento = "Crédito";
                break;
            }

            return transacao;
          });
          return newRes.transacoes[0];
        })
      );
  }

  update(transacao: TransacaoUpdated): Promise<void> {
    const url = `${this.transacoesUrl}/${transacao.id}`;

    const bodyRequest = {
      sob_suspeita: transacao.sob_suspeita,
    };
    return this.http
      .patch(url, JSON.stringify(bodyRequest), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => {
        let responseJson = res;
        this.router.navigate([
          "/pages/transacoes/transacao-detail/",
          responseJson.data.id,
        ]);
      });
  }

  create(transacao: TransacaoAddModel): Promise<any> {
    return this.http
      .post(this.transacoesAddUrl, JSON.stringify(transacao), {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((res) => res);
  }

  getOrganizacao(params?: HttpParams): Observable<Array<any>> {
    let headers = this.getHeaders();
    let url = this.organizacaoUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res.data));
  }
}
